module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFR.f1baaea4.otf";